import { useParams } from "react-router";
import { Card, EmptyState, Button } from "@salesapp/ui";
import { findAppByCode } from "../lib/appRegistry";
import { getAppIcon } from "../shell/appIcons";

/**
 * Rendered for any app_code route that has a nav entry but no real UI yet.
 * Once an app is built, its route swaps this out for the real page —
 * nothing else in the shell changes.
 */
export function PlaceholderAppPage() {
  const { appCode } = useParams<{ appCode: string }>();
  const entry = appCode ? findAppByCode(appCode) : undefined;

  return (
    <Card>
      <EmptyState
        icon={<span className="placeholder-app-icon">{getAppIcon(entry?.appCode ?? appCode ?? "")}</span>}
        title={`${entry?.label ?? appCode} is coming soon`}
        description="This app hasn't been built yet. It will appear here once it ships."
        action={
          <Button variant="secondary" onClick={() => window.history.back()}>
            Go back
          </Button>
        }
      />
    </Card>
  );
}
